import type { MarketVariants } from '@/lib/i18n'

export type Slide12Copy = {
  title: string
}

export const copy: MarketVariants<Slide12Copy> = {
  US: {
    title: 'The good news?',
  },
  ar: {
    title: 'الخبر السار؟',
  },
}
